import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  const [showVideo, setShowVideo] = useState(false);

  const handleExploreServices = () => {
    const servicesSection = document.getElementById('services');
    if (servicesSection) {
      servicesSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/services');
    }
  };

  const handleWatchStory = () => {
    setShowVideo(true);
  };
  return (
    <section className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <motion.div 
            className="hero-text"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1>Leading Web Development & Digital Transformation Company - AuVSys</h1>
            <p>
              Premier web development company delivering cutting-edge digital solutions worldwide. 
              Specializing in custom web development, AI integration, cloud services, and enterprise 
              digital transformation. Transform your business with our expert web development team.
            </p>
            
            <div className="hero-stats">
              <div className="stat">
                <span className="stat-number">500+</span>
                <span className="stat-label">Global Clients</span>
              </div>
              <div className="stat">
                <span className="stat-number">50+</span>
                <span className="stat-label">Countries</span>
              </div>
              <div className="stat">
                <span className="stat-number">25+</span>
                <span className="stat-label">Years Experience</span>
              </div>
            </div>

            <div className="hero-actions">
              <button className="btn-primary" onClick={handleExploreServices}>
                Explore Services <ArrowRight size={20} />
              </button>
              <button className="btn-secondary" onClick={handleWatchStory}>
                <Play size={20} /> Watch Our Story
              </button>
            </div>
          </motion.div>

          <motion.div 
            className="hero-visual"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="tech-grid">
              <div className="tech-card ai">
                <h3>AI & ML</h3>
                <p>Intelligent automation</p>
              </div>
              <div className="tech-card cloud">
                <h3>Cloud</h3>
                <p>Scalable infrastructure</p>
              </div>
              <div className="tech-card security">
                <h3>Security</h3>
                <p>Zero-trust architecture</p>
              </div>
              <div className="tech-card data">
                <h3>Data</h3>
                <p>Analytics & insights</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-line"></div>
      </div>
      
      {showVideo && (
        <div className="video-modal">
          <div className="video-overlay" onClick={() => setShowVideo(false)}></div>
          <div className="video-container">
            <button className="close-video" onClick={() => setShowVideo(false)}>
              <X size={24} />
            </button>
            <iframe
              width="800"
              height="450"
              src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1"
              title="AuVSys Company Story"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;